import { useTranslation } from 'next-i18next';
import { FilterType, freeFormHubFilterKeys } from '../../types';
import { FilterWrapper } from '../filterWrapper/filterWrapper';
import { useFreeFormHubInputValidator } from '../../hooks/inputValidator';
import { useFreeFormHubFilterState } from '../../hooks/useUrlFilterState';
import { v4 } from 'uuid';

export const NutritionSection = () => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  const checkboxValidator = useFreeFormHubInputValidator(FilterType.CHECKBOX);
  const [fdaValue, setFdaValue] = useFreeFormHubFilterState<FilterType.CHECKBOX>(
    freeFormHubFilterKeys.FDA_COMPLIANCE,
    checkboxValidator
  );
  const [euValue, setEuValue] = useFreeFormHubFilterState<FilterType.CHECKBOX>(
    freeFormHubFilterKeys.EU102011_COMPLIANCE,
    checkboxValidator
  );

  const SectionConfig = [
    {
      type: FilterType.CHECKBOX,
      props: {
        key: freeFormHubFilterKeys.FDA_COMPLIANCE,
        id: freeFormHubFilterKeys.FDA_COMPLIANCE,
        label: t(`FILTERS.LABELS.FDA_COMPLIANCE`, { ns: 'free-form-hub/freeFormHub' }),
        disabled: false,
        value: fdaValue ?? false,
        onChange: newValue => {
          setFdaValue(newValue === true ? true : undefined);
        },
      },
    },
    {
      type: FilterType.CHECKBOX,
      props: {
        key: freeFormHubFilterKeys.EU102011_COMPLIANCE,
        id: freeFormHubFilterKeys.EU102011_COMPLIANCE,
        label: t(`FILTERS.LABELS.EU102011_COMPLIANCE`, { ns: 'free-form-hub/freeFormHub' }),
        disabled: false,
        value: euValue ?? false,
        onChange: newValue => {
          setEuValue(newValue === true ? true : undefined);
        },
      },
    },
  ];

  return (
    <>
      {SectionConfig.map(filter => {
        const uuId = v4();

        return (
          <div className="mt-8" key={uuId}>
            <FilterWrapper type={filter.type} props={filter.props} />
          </div>
        );
      })}
    </>
  );
};
